//公钥
const publicKey = '047cce3abce22546a522d949b0c5e696e6eeb47d66421f728e19ba6e927e2b13446be37579eea04fd22bd25a6fb0f0cbf63ad8833f1e25bf9029fdd4b7018ce84e';

const sm2 = require('sm-crypto').sm2

export function doEncrypt(value) {
  if (value !== null && value !== '' && value !== undefined) {
    return "04" + sm2.doEncrypt(value, publicKey, 1);
  }
  return value;
}
